import requestHelper from '@/helpers/store/requestHelper'
import { saveRightOrderDomains } from '@/helpers/store/saveRightOrderDomains'

export const deviceDistribution = {
  namespaced: true,
  actions: {
    async load(ctx) {
      await requestHelper(
        {
          url: '/data/getDeviceDistribution',
          viewId: ctx.rootState.view.viewId,
        },
        ctx
      )
    },
  },
  state: () => ({
    data: [],
    loading: true,
    error: { status: false },
  }),
  mutations: {
    updateData(state, data) {
      state.data = data.map(item => ({
        domainName: item.domainName,
        desktop: item.data?.desktop ?? null,
        phone: item.data?.phone ?? null,
      }))
    },
    updateLoading(state, status) {
      state.loading = status
    },
    updateError(state, data) {
      state.error = data
    },
  },
  getters: {
    dataOnActualDate(state, getters, rootState, rootGetters) {
      const { domains } = rootGetters
      return saveRightOrderDomains(state.data, domains)
    },
  },
}
